import React from 'react';

import { useHistory } from 'react-router';
import { Typography } from '@material-ui/core';
import { CustomCard } from '../Card/Card';
import EarthLogo from '../../assets/earth-lines.png';
import ProjectCard from './ProjectCard';
import { DSButton } from '../Button/Button';
import { StyledList, StyledCreateProjectCard } from '../../styles/templates/Projects';
import { ApplicationInterface } from '../../interfaces/application';

type ProjectListProps = {
  projects: ApplicationInterface[];
  onNewProject: () => void;
};

const ProjectList: React.FC<ProjectListProps> = ({ projects, onNewProject }) => {
  const history = useHistory();

  const onProjectClick = (project: ApplicationInterface) => {
    history.push(`/projects/details/${project.info.applicationId}`);
  };

  return (
    <StyledList>
      <CustomCard thin>
        <StyledCreateProjectCard>
          <Typography variant="h1">Create a new project</Typography>
          <img src={EarthLogo} alt="New Project" width="127" height="113" />

          <DSButton onClick={onNewProject}>New Project</DSButton>
        </StyledCreateProjectCard>
      </CustomCard>

      {projects.map((project) => (
        <ProjectCard
          key={project.info.applicationId}
          project={project}
          onClick={() => onProjectClick(project)}
        />
      ))}
    </StyledList>
  );
};

export default ProjectList;
